/* import __COLOCATED_TEMPLATE__ from './application-banner-messages.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import {
  BANNER_MESSAGE_TYPES
} from "../services/states/application";

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: 'section',
  classNames: ['SH-c-application-banner-messages'],
  classNameBindings: ['_hasNoBannerMessage:hide'],

  /**
   * Register services
   */
  applicationState: service('states/application'),
  applicationStateManager: service('state-managers/application'),

  /**
   * @type {Object}     Optional bag of meta info dependent on banner message type
   */
  _bannerMessageMeta: readOnly('applicationState.bannerMessageMeta'),

  /**
   * @inheritDoc - from applicationState.
   */
  _bannerMessageType: readOnly('applicationState.bannerMessageType'),

  /**
   * Message type constants available
   *
   * @type {Object}
   */
  _messageTypeConstants: BANNER_MESSAGE_TYPES,

  /**
   * True if we do NOT have a banner message.
   *
   * @type {Boolean}
   */
  _hasNoBannerMessage: computed('_bannerMessageType', function() {
    return !this.get('_bannerMessageType');
  }),

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * Called when the user clicks to dismiss the banner message.
     */
    onBannerMessageDismissClicked: function() {
      this.get('applicationStateManager').dismissBannerMessage();
    },

    /**
     * User has clicked to decline all pending applications.
     */
    onDeclineAllPendingApplicationsClicked() {
      this.get('applicationStateManager').declineAllPendingApplications();
    }
  }
});
